const accessDetailsParens = invitation => {
  if (!invitation || !invitation.is_admin || !invitation.is_agency_user) return ''
  if (invitation.is_admin && invitation.is_agency_user) return '(Admin and Multi-Company Access)'
  return invitation.is_admin ? '(Admin)' : '(Multi-Company Access)'
}

const AccessDetails = ({ invitation }) => {
  return (
    (invitation.access_type === 'company') ?
      <span>Global { accessDetailsParens(invitation) }</span> :
      <span>Projects: <small><em>{invitation.project_names.join(', ')}</em></small></span>
  )
}

export default AccessDetails



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/user-invitations/components/AccessDetails.js